import { emptySplitApi as api } from "./emptyApi";
export const addTagTypes = [
  "AdminControllers",
  "Updates",
  "Controllers",
  "AdminUsers",
  "AdminUpdateUserPassword",
  "AdminSendNewUserPassword",
  "Alarms",
  "Meters",
  "Metrics",
  "UpdateLogs",
  "MeterSettings",
  "NotificationSettings",
  "Energy",
  "Auth",
  "Settings",
  "Statistics",
  "Tenants",
  "User",
] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getApiAdminControllersV1: build.query<
        GetApiAdminControllersV1ApiResponse,
        GetApiAdminControllersV1ApiArg
      >({
        query: () => ({ url: `/api/admin/controllers-v1` }),
        providesTags: ["AdminControllers"],
      }),
      postApiAdminControllersV1: build.mutation<
        PostApiAdminControllersV1ApiResponse,
        PostApiAdminControllersV1ApiArg
      >({
        query: (queryArg) => ({
          url: `/api/admin/controllers-v1`,
          method: "POST",
          body: queryArg.githubComNergySeNubesPkgApiV1ModelsAdminCreateControllerRequest,
        }),
        invalidatesTags: ["AdminControllers"],
      }),
      getApiAdminControllersV1ById: build.query<
        GetApiAdminControllersV1ByIdApiResponse,
        GetApiAdminControllersV1ByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/admin/controllers-v1/${queryArg.id}`,
        }),
        providesTags: ["AdminControllers"],
      }),
      putApiAdminControllersV1ById: build.mutation<
        PutApiAdminControllersV1ByIdApiResponse,
        PutApiAdminControllersV1ByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/admin/controllers-v1/${queryArg.id}`,
          method: "PUT",
          body: queryArg.githubComNergySeNubesPkgApiV1ModelsUpdateControllerRequest,
        }),
        invalidatesTags: ["AdminControllers"],
      }),
      putApiAdminControllersV1ByIdDisabledV1: build.mutation<
        PutApiAdminControllersV1ByIdDisabledV1ApiResponse,
        PutApiAdminControllersV1ByIdDisabledV1ApiArg
      >({
        query: (queryArg) => ({
          url: `/api/admin/controllers-v1/${queryArg.id}/disabled-v1`,
          method: "PUT",
          body: queryArg.body,
        }),
        invalidatesTags: ["AdminControllers"],
      }),
      postApiAdminToolsV1TestSendEmailV1: build.mutation<
        PostApiAdminToolsV1TestSendEmailV1ApiResponse,
        PostApiAdminToolsV1TestSendEmailV1ApiArg
      >({
        query: (queryArg) => ({
          url: `/api/admin/tools-v1/test-send-email-v1`,
          method: "POST",
          body: queryArg.body,
        }),
      }),
      getApiAdminUpdatesV1: build.query<
        GetApiAdminUpdatesV1ApiResponse,
        GetApiAdminUpdatesV1ApiArg
      >({
        query: () => ({ url: `/api/admin/updates-v1` }),
        providesTags: ["Updates"],
      }),
      postApiAdminUpdatesV1: build.mutation<
        PostApiAdminUpdatesV1ApiResponse,
        PostApiAdminUpdatesV1ApiArg
      >({
        query: (queryArg) => ({
          url: `/api/admin/updates-v1`,
          method: "POST",
          body: queryArg.githubComNergySeNubesPkgApiV1ModelsUpdate,
        }),
        invalidatesTags: ["Updates"],
      }),
      getApiAdminUpdatesV1ById: build.query<
        GetApiAdminUpdatesV1ByIdApiResponse,
        GetApiAdminUpdatesV1ByIdApiArg
      >({
        query: (queryArg) => ({ url: `/api/admin/updates-v1/${queryArg.id}` }),
        providesTags: ["Updates"],
      }),
      putApiAdminUpdatesV1ById: build.mutation<
        PutApiAdminUpdatesV1ByIdApiResponse,
        PutApiAdminUpdatesV1ByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/admin/updates-v1/${queryArg.id}`,
          method: "PUT",
          body: queryArg.githubComNergySeNubesPkgApiV1ModelsUpdate,
        }),
        invalidatesTags: ["Updates"],
      }),
      deleteApiAdminUpdatesV1ById: build.mutation<
        DeleteApiAdminUpdatesV1ByIdApiResponse,
        DeleteApiAdminUpdatesV1ByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/admin/updates-v1/${queryArg.id}`,
          method: "DELETE",
        }),
        invalidatesTags: ["Updates"],
      }),
      postApiAdminUpdatesV1ByIdAssign: build.mutation<
        PostApiAdminUpdatesV1ByIdAssignApiResponse,
        PostApiAdminUpdatesV1ByIdAssignApiArg
      >({
        query: (queryArg) => ({
          url: `/api/admin/updates-v1/${queryArg.id}/assign`,
          method: "POST",
          body: queryArg.body,
        }),
        invalidatesTags: ["Controllers"],
      }),
      getApiAdminUsersV1: build.query<
        GetApiAdminUsersV1ApiResponse,
        GetApiAdminUsersV1ApiArg
      >({
        query: (queryArg) => ({
          url: `/api/admin/users-v1`,
          params: {
            tenantId: queryArg.tenantId,
          },
        }),
        providesTags: ["AdminUsers"],
      }),
      postApiAdminUsersV1: build.mutation<
        PostApiAdminUsersV1ApiResponse,
        PostApiAdminUsersV1ApiArg
      >({
        query: (queryArg) => ({
          url: `/api/admin/users-v1`,
          method: "POST",
          body: queryArg.githubComNergySeNubesPkgApiV1ModelsUser,
        }),
        invalidatesTags: ["AdminUsers"],
      }),
      getApiAdminUsersV1ById: build.query<
        GetApiAdminUsersV1ByIdApiResponse,
        GetApiAdminUsersV1ByIdApiArg
      >({
        query: (queryArg) => ({ url: `/api/admin/users-v1/${queryArg.id}` }),
        providesTags: ["AdminUsers"],
      }),
      putApiAdminUsersV1ById: build.mutation<
        PutApiAdminUsersV1ByIdApiResponse,
        PutApiAdminUsersV1ByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/admin/users-v1/${queryArg.id}`,
          method: "PUT",
          body: queryArg.githubComNergySeNubesPkgApiV1ModelsUser,
        }),
        invalidatesTags: ["AdminUsers"],
      }),
      postApiAdminUsersV1ByIdResetPassword: build.mutation<
        PostApiAdminUsersV1ByIdResetPasswordApiResponse,
        PostApiAdminUsersV1ByIdResetPasswordApiArg
      >({
        query: (queryArg) => ({
          url: `/api/admin/users-v1/${queryArg.id}/reset-password`,
          method: "POST",
          body: queryArg.body,
        }),
        invalidatesTags: ["AdminUpdateUserPassword"],
      }),
      postApiAdminUsersV1ByIdSendPasswordV1: build.mutation<
        PostApiAdminUsersV1ByIdSendPasswordV1ApiResponse,
        PostApiAdminUsersV1ByIdSendPasswordV1ApiArg
      >({
        query: (queryArg) => ({
          url: `/api/admin/users-v1/${queryArg.id}/send-password-v1`,
          method: "POST",
        }),
        invalidatesTags: ["AdminSendNewUserPassword"],
      }),
      postApiControllerAlarmV1: build.mutation<
        PostApiControllerAlarmV1ApiResponse,
        PostApiControllerAlarmV1ApiArg
      >({
        query: (queryArg) => ({
          url: `/api/controller/alarm-v1`,
          method: "POST",
          body: queryArg.body,
        }),
        invalidatesTags: ["Alarms"],
      }),
      deleteApiControllerAlarmsV1: build.mutation<
        DeleteApiControllerAlarmsV1ApiResponse,
        DeleteApiControllerAlarmsV1ApiArg
      >({
        query: () => ({ url: `/api/controller/alarms-v1`, method: "DELETE" }),
        invalidatesTags: ["Alarms"],
      }),
      getApiControllerBundlesV1ById: build.query<
        GetApiControllerBundlesV1ByIdApiResponse,
        GetApiControllerBundlesV1ByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/controller/bundles-v1/${queryArg.id}`,
        }),
      }),
      getApiControllerConfigV1: build.query<
        GetApiControllerConfigV1ApiResponse,
        GetApiControllerConfigV1ApiArg
      >({
        query: () => ({ url: `/api/controller/config-v1` }),
        providesTags: ["Controllers"],
      }),
      postApiControllerConfigV1: build.mutation<
        PostApiControllerConfigV1ApiResponse,
        PostApiControllerConfigV1ApiArg
      >({
        query: (queryArg) => ({
          url: `/api/controller/config-v1`,
          method: "POST",
          body: queryArg.githubComNergySeNubesPkgApiV1ModelsControllerConfig,
        }),
        invalidatesTags: ["Controllers"],
      }),
      postApiControllerHeatcurveV1: build.mutation<
        PostApiControllerHeatcurveV1ApiResponse,
        PostApiControllerHeatcurveV1ApiArg
      >({
        query: (queryArg) => ({
          url: `/api/controller/heatcurve-v1`,
          method: "POST",
          body: queryArg.githubComNergySeNubesPkgApiV1ModelsControllerConfig,
        }),
        invalidatesTags: ["Controllers"],
      }),
      postApiControllerMeterV1: build.mutation<
        PostApiControllerMeterV1ApiResponse,
        PostApiControllerMeterV1ApiArg
      >({
        query: (queryArg) => ({
          url: `/api/controller/meter-v1`,
          method: "POST",
          body: queryArg.meterData,
        }),
        invalidatesTags: ["Meters"],
      }),
      postApiControllerMetricsV1: build.mutation<
        PostApiControllerMetricsV1ApiResponse,
        PostApiControllerMetricsV1ApiArg
      >({
        query: (queryArg) => ({
          url: `/api/controller/metrics-v1`,
          method: "POST",
          body: queryArg.githubComNergySeNubesPkgApiV1StateState,
        }),
        invalidatesTags: ["Metrics"],
      }),
      getApiControllerScheduleV1: build.query<
        GetApiControllerScheduleV1ApiResponse,
        GetApiControllerScheduleV1ApiArg
      >({
        query: () => ({ url: `/api/controller/schedule-v1` }),
        providesTags: ["Controllers"],
      }),
      postApiControllerUpdateLogV1: build.mutation<
        PostApiControllerUpdateLogV1ApiResponse,
        PostApiControllerUpdateLogV1ApiArg
      >({
        query: (queryArg) => ({
          url: `/api/controller/update-log-v1`,
          method: "POST",
          body: queryArg.githubComNergySeNubesPkgApiV1ModelsUpdateLog,
        }),
        invalidatesTags: ["UpdateLogs"],
      }),
      getApiControllerUpdateV1: build.query<
        GetApiControllerUpdateV1ApiResponse,
        GetApiControllerUpdateV1ApiArg
      >({
        query: (queryArg) => ({
          url: `/api/controller/update-v1`,
          params: {
            serial: queryArg.serial,
            version: queryArg.version,
          },
        }),
      }),
      getApiControllersV1: build.query<
        GetApiControllersV1ApiResponse,
        GetApiControllersV1ApiArg
      >({
        query: () => ({ url: `/api/controllers-v1` }),
        providesTags: ["Controllers"],
      }),
      postApiControllersV1: build.mutation<
        PostApiControllersV1ApiResponse,
        PostApiControllersV1ApiArg
      >({
        query: (queryArg) => ({
          url: `/api/controllers-v1`,
          method: "POST",
          body: queryArg.githubComNergySeNubesPkgApiV1ModelsCreateControllerRequest,
        }),
        invalidatesTags: ["Controllers"],
      }),
      getApiControllersV1ById: build.query<
        GetApiControllersV1ByIdApiResponse,
        GetApiControllersV1ByIdApiArg
      >({
        query: (queryArg) => ({ url: `/api/controllers-v1/${queryArg.id}` }),
        providesTags: ["Controllers"],
      }),
      putApiControllersV1ById: build.mutation<
        PutApiControllersV1ByIdApiResponse,
        PutApiControllersV1ByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/controllers-v1/${queryArg.id}`,
          method: "PUT",
          body: queryArg.githubComNergySeNubesPkgApiV1ModelsUpdateControllerRequest,
        }),
        invalidatesTags: ["Controllers"],
      }),
      getApiControllersV1ByIdAlarmsV1: build.query<
        GetApiControllersV1ByIdAlarmsV1ApiResponse,
        GetApiControllersV1ByIdAlarmsV1ApiArg
      >({
        query: (queryArg) => ({
          url: `/api/controllers-v1/${queryArg.id}/alarms-v1`,
        }),
        providesTags: ["Alarms"],
      }),
      getApiControllersV1ByIdLastmetricsV1: build.query<
        GetApiControllersV1ByIdLastmetricsV1ApiResponse,
        GetApiControllersV1ByIdLastmetricsV1ApiArg
      >({
        query: (queryArg) => ({
          url: `/api/controllers-v1/${queryArg.id}/lastmetrics-v1`,
        }),
        providesTags: ["Metrics"],
      }),
      getApiControllersV1ByIdMetersettingsV1: build.query<
        GetApiControllersV1ByIdMetersettingsV1ApiResponse,
        GetApiControllersV1ByIdMetersettingsV1ApiArg
      >({
        query: (queryArg) => ({
          url: `/api/controllers-v1/${queryArg.id}/metersettings-v1`,
        }),
        providesTags: ["MeterSettings"],
      }),
      postApiControllersV1ByIdMetersettingsV1: build.mutation<
        PostApiControllersV1ByIdMetersettingsV1ApiResponse,
        PostApiControllersV1ByIdMetersettingsV1ApiArg
      >({
        query: (queryArg) => ({
          url: `/api/controllers-v1/${queryArg.id}/metersettings-v1`,
          method: "POST",
          body: queryArg.githubComNergySeNubesPkgApiV1ModelsMeter,
        }),
        invalidatesTags: ["MeterSettings"],
      }),
      getApiControllersV1ByIdMetersettingsV1AndMeter: build.query<
        GetApiControllersV1ByIdMetersettingsV1AndMeterApiResponse,
        GetApiControllersV1ByIdMetersettingsV1AndMeterApiArg
      >({
        query: (queryArg) => ({
          url: `/api/controllers-v1/${queryArg.id}/metersettings-v1/${queryArg.meter}`,
        }),
        providesTags: ["MeterSettings"],
      }),
      putApiControllersV1ByIdMetersettingsV1AndMeter: build.mutation<
        PutApiControllersV1ByIdMetersettingsV1AndMeterApiResponse,
        PutApiControllersV1ByIdMetersettingsV1AndMeterApiArg
      >({
        query: (queryArg) => ({
          url: `/api/controllers-v1/${queryArg.id}/metersettings-v1/${queryArg.meter}`,
          method: "PUT",
          body: queryArg.githubComNergySeNubesPkgApiV1ModelsMeter,
        }),
        invalidatesTags: ["MeterSettings"],
      }),
      deleteApiControllersV1ByIdMetersettingsV1AndMeter: build.mutation<
        DeleteApiControllersV1ByIdMetersettingsV1AndMeterApiResponse,
        DeleteApiControllersV1ByIdMetersettingsV1AndMeterApiArg
      >({
        query: (queryArg) => ({
          url: `/api/controllers-v1/${queryArg.id}/metersettings-v1/${queryArg.meter}`,
          method: "DELETE",
        }),
        invalidatesTags: ["MeterSettings"],
      }),
      getApiControllersV1ByIdMetricsV1: build.query<
        GetApiControllersV1ByIdMetricsV1ApiResponse,
        GetApiControllersV1ByIdMetricsV1ApiArg
      >({
        query: (queryArg) => ({
          url: `/api/controllers-v1/${queryArg.id}/metrics-v1`,
          params: {
            duration: queryArg.duration,
            start: queryArg.start,
            stop: queryArg.stop,
          },
        }),
        providesTags: ["Metrics"],
      }),
      getApiControllersV1ByIdNotificationsettingsV1: build.query<
        GetApiControllersV1ByIdNotificationsettingsV1ApiResponse,
        GetApiControllersV1ByIdNotificationsettingsV1ApiArg
      >({
        query: (queryArg) => ({
          url: `/api/controllers-v1/${queryArg.id}/notificationsettings-v1`,
        }),
        providesTags: ["NotificationSettings"],
      }),
      postApiControllersV1ByIdNotificationsettingsV1: build.mutation<
        PostApiControllersV1ByIdNotificationsettingsV1ApiResponse,
        PostApiControllersV1ByIdNotificationsettingsV1ApiArg
      >({
        query: (queryArg) => ({
          url: `/api/controllers-v1/${queryArg.id}/notificationsettings-v1`,
          method: "POST",
          body: queryArg.githubComNergySeNubesPkgApiV1ModelsNotificationSetting,
        }),
        invalidatesTags: ["NotificationSettings"],
      }),
      getApiControllersV1ByIdNotificationsettingsV1AndSetting: build.query<
        GetApiControllersV1ByIdNotificationsettingsV1AndSettingApiResponse,
        GetApiControllersV1ByIdNotificationsettingsV1AndSettingApiArg
      >({
        query: (queryArg) => ({
          url: `/api/controllers-v1/${queryArg.id}/notificationsettings-v1/${queryArg.setting}`,
        }),
        providesTags: ["NotificationSettings"],
      }),
      putApiControllersV1ByIdNotificationsettingsV1AndSetting: build.mutation<
        PutApiControllersV1ByIdNotificationsettingsV1AndSettingApiResponse,
        PutApiControllersV1ByIdNotificationsettingsV1AndSettingApiArg
      >({
        query: (queryArg) => ({
          url: `/api/controllers-v1/${queryArg.id}/notificationsettings-v1/${queryArg.setting}`,
          method: "PUT",
          body: queryArg.githubComNergySeNubesPkgApiV1ModelsNotificationSetting,
        }),
        invalidatesTags: ["NotificationSettings"],
      }),
      deleteApiControllersV1ByIdNotificationsettingsV1AndSetting:
        build.mutation<
          DeleteApiControllersV1ByIdNotificationsettingsV1AndSettingApiResponse,
          DeleteApiControllersV1ByIdNotificationsettingsV1AndSettingApiArg
        >({
          query: (queryArg) => ({
            url: `/api/controllers-v1/${queryArg.id}/notificationsettings-v1/${queryArg.setting}`,
            method: "DELETE",
          }),
          invalidatesTags: ["NotificationSettings"],
        }),
      getApiEnergyPricesV1: build.query<
        GetApiEnergyPricesV1ApiResponse,
        GetApiEnergyPricesV1ApiArg
      >({
        query: (queryArg) => ({
          url: `/api/energy/prices-v1`,
          params: {
            from: queryArg["from"],
            to: queryArg.to,
          },
        }),
        providesTags: ["Energy"],
      }),
      postApiLoginV1: build.mutation<
        PostApiLoginV1ApiResponse,
        PostApiLoginV1ApiArg
      >({
        query: (queryArg) => ({
          url: `/api/login-v1`,
          method: "POST",
          body: queryArg.body,
        }),
        invalidatesTags: ["Auth"],
      }),
      getApiLogoutV1: build.query<
        GetApiLogoutV1ApiResponse,
        GetApiLogoutV1ApiArg
      >({
        query: () => ({ url: `/api/logout-v1` }),
        providesTags: ["Auth"],
      }),
      postApiResetPasswordV1ByToken: build.mutation<
        PostApiResetPasswordV1ByTokenApiResponse,
        PostApiResetPasswordV1ByTokenApiArg
      >({
        query: (queryArg) => ({
          url: `/api/reset-password-v1/${queryArg.token}`,
          method: "POST",
          body: queryArg.body,
        }),
        invalidatesTags: ["Auth"],
      }),
      getApiSettingsV1: build.query<
        GetApiSettingsV1ApiResponse,
        GetApiSettingsV1ApiArg
      >({
        query: () => ({ url: `/api/settings-v1` }),
        providesTags: ["Settings"],
      }),
      putApiSettingsV1: build.mutation<
        PutApiSettingsV1ApiResponse,
        PutApiSettingsV1ApiArg
      >({
        query: (queryArg) => ({
          url: `/api/settings-v1`,
          method: "PUT",
          body: queryArg.githubComNergySeNubesPkgApiV1ModelsTenant,
        }),
        invalidatesTags: ["Settings"],
      }),
      getApiStatisticsConsumptionV1: build.query<
        GetApiStatisticsConsumptionV1ApiResponse,
        GetApiStatisticsConsumptionV1ApiArg
      >({
        query: (queryArg) => ({
          url: `/api/statistics/consumption-v1`,
          params: {
            start: queryArg.start,
            stop: queryArg.stop,
            groupby: queryArg.groupby,
            controllerIds: queryArg.controllerIds,
            position: queryArg.position,
          },
        }),
        providesTags: ["Statistics"],
      }),
      getApiTenantsV1: build.query<
        GetApiTenantsV1ApiResponse,
        GetApiTenantsV1ApiArg
      >({
        query: () => ({ url: `/api/tenants-v1` }),
        providesTags: ["Tenants"],
      }),
      postApiTenantsV1: build.mutation<
        PostApiTenantsV1ApiResponse,
        PostApiTenantsV1ApiArg
      >({
        query: (queryArg) => ({
          url: `/api/tenants-v1`,
          method: "POST",
          body: queryArg.githubComNergySeNubesPkgApiV1ModelsTenant,
        }),
        invalidatesTags: ["Tenants"],
      }),
      getApiTenantsV1ById: build.query<
        GetApiTenantsV1ByIdApiResponse,
        GetApiTenantsV1ByIdApiArg
      >({
        query: (queryArg) => ({ url: `/api/tenants-v1/${queryArg.id}` }),
        providesTags: ["Tenants"],
      }),
      putApiTenantsV1ById: build.mutation<
        PutApiTenantsV1ByIdApiResponse,
        PutApiTenantsV1ByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/tenants-v1/${queryArg.id}`,
          method: "PUT",
          body: queryArg.githubComNergySeNubesPkgApiV1ModelsTenant,
        }),
        invalidatesTags: ["Tenants"],
      }),
      postApiTenantsV1ByIdSupportLoginV1: build.mutation<
        PostApiTenantsV1ByIdSupportLoginV1ApiResponse,
        PostApiTenantsV1ByIdSupportLoginV1ApiArg
      >({
        query: (queryArg) => ({
          url: `/api/tenants-v1/${queryArg.id}/support-login-v1`,
          method: "POST",
        }),
        invalidatesTags: ["Tenants"],
      }),
      postApiTokenV1: build.mutation<
        PostApiTokenV1ApiResponse,
        PostApiTokenV1ApiArg
      >({
        query: (queryArg) => ({
          url: `/api/token-v1`,
          method: "POST",
          body: queryArg.body,
        }),
        invalidatesTags: ["Auth"],
      }),
      getApiUsersV1: build.query<GetApiUsersV1ApiResponse, GetApiUsersV1ApiArg>(
        {
          query: () => ({ url: `/api/users-v1` }),
          providesTags: ["User"],
        },
      ),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as newApi };
export type GetApiAdminControllersV1ApiResponse =
  /** status 200 OK */ PkgApiserverWebhandlersControllersResponse[];
export type GetApiAdminControllersV1ApiArg = void;
export type PostApiAdminControllersV1ApiResponse =
  /** status 200 OK */ GithubComNergySeNubesPkgApiV1ModelsController;
export type PostApiAdminControllersV1ApiArg = {
  /** Controller object */
  githubComNergySeNubesPkgApiV1ModelsAdminCreateControllerRequest: GithubComNergySeNubesPkgApiV1ModelsAdminCreateControllerRequest;
};
export type GetApiAdminControllersV1ByIdApiResponse =
  /** status 200 OK */ GithubComNergySeNubesPkgApiV1ModelsController;
export type GetApiAdminControllersV1ByIdApiArg = {
  /** Controller ID */
  id: string;
};
export type PutApiAdminControllersV1ByIdApiResponse =
  /** status 200 OK */ GithubComNergySeNubesPkgApiV1ModelsController;
export type PutApiAdminControllersV1ByIdApiArg = {
  /** Controller ID */
  id: string;
  /** Controller update payload */
  githubComNergySeNubesPkgApiV1ModelsUpdateControllerRequest: GithubComNergySeNubesPkgApiV1ModelsUpdateControllerRequest;
};
export type PutApiAdminControllersV1ByIdDisabledV1ApiResponse =
  /** status 200 OK */ GithubComNergySeNubesPkgApiV1ModelsController;
export type PutApiAdminControllersV1ByIdDisabledV1ApiArg = {
  /** Controller ID */
  id: string;
  /** Object with disabled field set to true or false */
  body: object;
};
export type PostApiAdminToolsV1TestSendEmailV1ApiResponse = unknown;
export type PostApiAdminToolsV1TestSendEmailV1ApiArg = {
  /** Email details */
  body: {
    toMail?: string;
    toName?: string;
    type?: string;
  };
};
export type GetApiAdminUpdatesV1ApiResponse =
  /** status 200 OK */ GithubComNergySeNubesPkgApiV1ModelsUpdate[];
export type GetApiAdminUpdatesV1ApiArg = void;
export type PostApiAdminUpdatesV1ApiResponse =
  /** status 201 Created */ GithubComNergySeNubesPkgApiV1ModelsUpdate;
export type PostApiAdminUpdatesV1ApiArg = {
  /** Update object */
  githubComNergySeNubesPkgApiV1ModelsUpdate: GithubComNergySeNubesPkgApiV1ModelsUpdate;
};
export type GetApiAdminUpdatesV1ByIdApiResponse =
  /** status 200 OK */ PkgApiserverWebhandlersUpdateResponse;
export type GetApiAdminUpdatesV1ByIdApiArg = {
  /** Update ID */
  id: string;
};
export type PutApiAdminUpdatesV1ByIdApiResponse =
  /** status 200 OK */ GithubComNergySeNubesPkgApiV1ModelsUpdate;
export type PutApiAdminUpdatesV1ByIdApiArg = {
  /** Update ID */
  id: string;
  /** Update object */
  githubComNergySeNubesPkgApiV1ModelsUpdate: GithubComNergySeNubesPkgApiV1ModelsUpdate;
};
export type DeleteApiAdminUpdatesV1ByIdApiResponse = unknown;
export type DeleteApiAdminUpdatesV1ByIdApiArg = {
  /** Update ID */
  id: string;
};
export type PostApiAdminUpdatesV1ByIdAssignApiResponse = unknown;
export type PostApiAdminUpdatesV1ByIdAssignApiArg = {
  /** Update ID */
  id: string;
  /** List of Controller IDs */
  body: string[];
};
export type GetApiAdminUsersV1ApiResponse =
  /** status 200 OK */ GithubComNergySeNubesPkgApiV1ModelsUser[];
export type GetApiAdminUsersV1ApiArg = {
  /** Tenant ID */
  tenantId?: string;
};
export type PostApiAdminUsersV1ApiResponse =
  /** status 200 OK */ GithubComNergySeNubesPkgApiV1ModelsUser;
export type PostApiAdminUsersV1ApiArg = {
  /** User object */
  githubComNergySeNubesPkgApiV1ModelsUser: GithubComNergySeNubesPkgApiV1ModelsUser;
};
export type GetApiAdminUsersV1ByIdApiResponse =
  /** status 200 OK */ GithubComNergySeNubesPkgApiV1ModelsUser;
export type GetApiAdminUsersV1ByIdApiArg = {
  /** User ID */
  id: string;
};
export type PutApiAdminUsersV1ByIdApiResponse =
  /** status 200 OK */ GithubComNergySeNubesPkgApiV1ModelsUser;
export type PutApiAdminUsersV1ByIdApiArg = {
  /** User ID */
  id: string;
  /** User object */
  githubComNergySeNubesPkgApiV1ModelsUser: GithubComNergySeNubesPkgApiV1ModelsUser;
};
export type PostApiAdminUsersV1ByIdResetPasswordApiResponse = unknown;
export type PostApiAdminUsersV1ByIdResetPasswordApiArg = {
  /** User ID */
  id: string;
  /** New password */
  body: {
    password?: string;
  };
};
export type PostApiAdminUsersV1ByIdSendPasswordV1ApiResponse = unknown;
export type PostApiAdminUsersV1ByIdSendPasswordV1ApiArg = {
  /** User ID */
  id: string;
};
export type PostApiControllerAlarmV1ApiResponse = unknown;
export type PostApiControllerAlarmV1ApiArg = {
  /** Alarm message */
  body: string;
};
export type DeleteApiControllerAlarmsV1ApiResponse = unknown;
export type DeleteApiControllerAlarmsV1ApiArg = void;
export type GetApiControllerBundlesV1ByIdApiResponse = unknown;
export type GetApiControllerBundlesV1ByIdApiArg = {
  /** Update ID */
  id: string;
};
export type GetApiControllerConfigV1ApiResponse =
  /** status 200 OK */ GithubComNergySeNubesPkgApiV1ModelsControllerConfig;
export type GetApiControllerConfigV1ApiArg = void;
export type PostApiControllerConfigV1ApiResponse = unknown;
export type PostApiControllerConfigV1ApiArg = {
  /** Controller config object */
  githubComNergySeNubesPkgApiV1ModelsControllerConfig: GithubComNergySeNubesPkgApiV1ModelsControllerConfig;
};
export type PostApiControllerHeatcurveV1ApiResponse = unknown;
export type PostApiControllerHeatcurveV1ApiArg = {
  /** Controller config object */
  githubComNergySeNubesPkgApiV1ModelsControllerConfig: GithubComNergySeNubesPkgApiV1ModelsControllerConfig;
};
export type PostApiControllerMeterV1ApiResponse = unknown;
export type PostApiControllerMeterV1ApiArg = {
  /** Meter data */
  meterData: MeterData;
};
export type PostApiControllerMetricsV1ApiResponse = unknown;
export type PostApiControllerMetricsV1ApiArg = {
  /** Controller state */
  githubComNergySeNubesPkgApiV1StateState: GithubComNergySeNubesPkgApiV1StateState;
};
export type GetApiControllerScheduleV1ApiResponse =
  /** status 200 OK */ PkgApiserverWebhandlersSchedule;
export type GetApiControllerScheduleV1ApiArg = void;
export type PostApiControllerUpdateLogV1ApiResponse = unknown;
export type PostApiControllerUpdateLogV1ApiArg = {
  /** Log data */
  githubComNergySeNubesPkgApiV1ModelsUpdateLog: GithubComNergySeNubesPkgApiV1ModelsUpdateLog;
};
export type GetApiControllerUpdateV1ApiResponse = unknown;
export type GetApiControllerUpdateV1ApiArg = {
  /** Controller serial number */
  serial: string;
  /** Current controller version */
  version: string;
};
export type GetApiControllersV1ApiResponse =
  /** status 200 OK */ GithubComNergySeNubesPkgApiV1ModelsController[];
export type GetApiControllersV1ApiArg = void;
export type PostApiControllersV1ApiResponse =
  /** status 200 OK */ GithubComNergySeNubesPkgApiV1ModelsController;
export type PostApiControllersV1ApiArg = {
  /** Controller object */
  githubComNergySeNubesPkgApiV1ModelsCreateControllerRequest: GithubComNergySeNubesPkgApiV1ModelsCreateControllerRequest;
};
export type GetApiControllersV1ByIdApiResponse =
  /** status 200 OK */ GithubComNergySeNubesPkgApiV1ModelsController;
export type GetApiControllersV1ByIdApiArg = {
  /** Controller ID */
  id: string;
};
export type PutApiControllersV1ByIdApiResponse =
  /** status 200 OK */ GithubComNergySeNubesPkgApiV1ModelsController;
export type PutApiControllersV1ByIdApiArg = {
  /** Controller ID */
  id: string;
  /** Controller update payload */
  githubComNergySeNubesPkgApiV1ModelsUpdateControllerRequest: GithubComNergySeNubesPkgApiV1ModelsUpdateControllerRequest;
};
export type GetApiControllersV1ByIdAlarmsV1ApiResponse =
  /** status 200 OK */ GithubComNergySeNubesPkgApiV1ModelsAlarm[];
export type GetApiControllersV1ByIdAlarmsV1ApiArg = {
  /** Controller ID */
  id: string;
};
export type GetApiControllersV1ByIdLastmetricsV1ApiResponse =
  /** status 200 OK */ {
    data?: object;
    last?: string;
  };
export type GetApiControllersV1ByIdLastmetricsV1ApiArg = {
  /** Controller ID */
  id: string;
};
export type GetApiControllersV1ByIdMetersettingsV1ApiResponse =
  /** status 200 OK */ GithubComNergySeNubesPkgApiV1ModelsMeter[];
export type GetApiControllersV1ByIdMetersettingsV1ApiArg = {
  /** Controller ID */
  id: string;
};
export type PostApiControllersV1ByIdMetersettingsV1ApiResponse =
  /** status 200 OK */ GithubComNergySeNubesPkgApiV1ModelsMeter;
export type PostApiControllersV1ByIdMetersettingsV1ApiArg = {
  /** Controller ID */
  id: string;
  /** Meter setting object */
  githubComNergySeNubesPkgApiV1ModelsMeter: GithubComNergySeNubesPkgApiV1ModelsMeter;
};
export type GetApiControllersV1ByIdMetersettingsV1AndMeterApiResponse =
  /** status 200 OK */ GithubComNergySeNubesPkgApiV1ModelsMeter;
export type GetApiControllersV1ByIdMetersettingsV1AndMeterApiArg = {
  /** Controller ID */
  id: string;
  /** Meter ID */
  meter: string;
};
export type PutApiControllersV1ByIdMetersettingsV1AndMeterApiResponse =
  /** status 200 OK */ GithubComNergySeNubesPkgApiV1ModelsMeter;
export type PutApiControllersV1ByIdMetersettingsV1AndMeterApiArg = {
  /** Controller ID */
  id: string;
  /** Meter ID */
  meter: string;
  /** Meter setting object */
  githubComNergySeNubesPkgApiV1ModelsMeter: GithubComNergySeNubesPkgApiV1ModelsMeter;
};
export type DeleteApiControllersV1ByIdMetersettingsV1AndMeterApiResponse =
  unknown;
export type DeleteApiControllersV1ByIdMetersettingsV1AndMeterApiArg = {
  /** Controller ID */
  id: string;
  /** Meter ID */
  meter: string;
};
export type GetApiControllersV1ByIdMetricsV1ApiResponse = /** status 200 OK */ {
  data?: object[];
};
export type GetApiControllersV1ByIdMetricsV1ApiArg = {
  /** Controller ID */
  id: string;
  /** Duration (e.g., '1h', '30m') */
  duration?: string;
  /** Start time (RFC3339Nano) */
  start?: string;
  /** Stop time (RFC3339Nano) */
  stop?: string;
};
export type GetApiControllersV1ByIdNotificationsettingsV1ApiResponse =
  /** status 200 OK */ GithubComNergySeNubesPkgApiV1ModelsNotificationSetting[];
export type GetApiControllersV1ByIdNotificationsettingsV1ApiArg = {
  /** Controller ID */
  id: string;
};
export type PostApiControllersV1ByIdNotificationsettingsV1ApiResponse =
  /** status 200 OK */ GithubComNergySeNubesPkgApiV1ModelsNotificationSetting;
export type PostApiControllersV1ByIdNotificationsettingsV1ApiArg = {
  /** Controller ID */
  id: string;
  /** Notification setting object */
  githubComNergySeNubesPkgApiV1ModelsNotificationSetting: GithubComNergySeNubesPkgApiV1ModelsNotificationSetting;
};
export type GetApiControllersV1ByIdNotificationsettingsV1AndSettingApiResponse =
  /** status 200 OK */ GithubComNergySeNubesPkgApiV1ModelsNotificationSetting;
export type GetApiControllersV1ByIdNotificationsettingsV1AndSettingApiArg = {
  /** Controller ID */
  id: string;
  /** Notification Setting ID */
  setting: string;
};
export type PutApiControllersV1ByIdNotificationsettingsV1AndSettingApiResponse =
  /** status 200 OK */ GithubComNergySeNubesPkgApiV1ModelsNotificationSetting;
export type PutApiControllersV1ByIdNotificationsettingsV1AndSettingApiArg = {
  /** Controller ID */
  id: string;
  /** Notification Setting ID */
  setting: string;
  /** Notification setting object */
  githubComNergySeNubesPkgApiV1ModelsNotificationSetting: GithubComNergySeNubesPkgApiV1ModelsNotificationSetting;
};
export type DeleteApiControllersV1ByIdNotificationsettingsV1AndSettingApiResponse =
  unknown;
export type DeleteApiControllersV1ByIdNotificationsettingsV1AndSettingApiArg = {
  /** Controller ID */
  id: string;
  /** Notification Setting ID */
  setting: string;
};
export type GetApiEnergyPricesV1ApiResponse =
  /** status 200 OK */ GithubComNergySeNubesPkgApiV1EnergyPrice[];
export type GetApiEnergyPricesV1ApiArg = {
  /** From date in format 2006-01-02 */
  from?: string;
  /** To date in format 2006-01-02 */
  to?: string;
};
export type PostApiLoginV1ApiResponse =
  /** status 200 OK */ GithubComNergySeNubesPkgApiV1ModelsUser;
export type PostApiLoginV1ApiArg = {
  /** Login credentials */
  body: {
    Password?: string;
    Username?: string;
  };
};
export type GetApiLogoutV1ApiResponse = unknown;
export type GetApiLogoutV1ApiArg = void;
export type PostApiResetPasswordV1ByTokenApiResponse = unknown;
export type PostApiResetPasswordV1ByTokenApiArg = {
  /** Password reset token */
  token: string;
  /** New password */
  body: {
    password?: string;
  };
};
export type GetApiSettingsV1ApiResponse =
  /** status 200 OK */ GithubComNergySeNubesPkgApiV1ModelsTenant;
export type GetApiSettingsV1ApiArg = void;
export type PutApiSettingsV1ApiResponse =
  /** status 200 OK */ GithubComNergySeNubesPkgApiV1ModelsTenant;
export type PutApiSettingsV1ApiArg = {
  /** Tenant settings object */
  githubComNergySeNubesPkgApiV1ModelsTenant: GithubComNergySeNubesPkgApiV1ModelsTenant;
};
export type GetApiStatisticsConsumptionV1ApiResponse = /** status 200 OK */ {
  data?: PkgApiserverWebhandlersConsumptionRow[];
};
export type GetApiStatisticsConsumptionV1ApiArg = {
  /** Start time (RFC3339Nano) */
  start: string;
  /** Stop time (RFC3339Nano) */
  stop: string;
  /** Group by 'h', 'd', 'm', or 'y' */
  groupby: string;
  /** Comma-separated list of controller IDs */
  controllerIds: string;
  /** Position (e.g., 'heatpump_electric') */
  position?: string;
};
export type GetApiTenantsV1ApiResponse =
  /** status 200 OK */ GithubComNergySeNubesPkgApiV1ModelsTenant[];
export type GetApiTenantsV1ApiArg = void;
export type PostApiTenantsV1ApiResponse =
  /** status 200 OK */ GithubComNergySeNubesPkgApiV1ModelsTenant;
export type PostApiTenantsV1ApiArg = {
  /** Tenant object */
  githubComNergySeNubesPkgApiV1ModelsTenant: GithubComNergySeNubesPkgApiV1ModelsTenant;
};
export type GetApiTenantsV1ByIdApiResponse =
  /** status 200 OK */ GithubComNergySeNubesPkgApiV1ModelsTenant;
export type GetApiTenantsV1ByIdApiArg = {
  /** Tenant ID */
  id: string;
};
export type PutApiTenantsV1ByIdApiResponse =
  /** status 200 OK */ GithubComNergySeNubesPkgApiV1ModelsTenant;
export type PutApiTenantsV1ByIdApiArg = {
  /** Tenant ID */
  id: string;
  /** Tenant object */
  githubComNergySeNubesPkgApiV1ModelsTenant: GithubComNergySeNubesPkgApiV1ModelsTenant;
};
export type PostApiTenantsV1ByIdSupportLoginV1ApiResponse =
  /** status 200 OK */ GithubComNergySeNubesPkgApiV1ModelsUser;
export type PostApiTenantsV1ByIdSupportLoginV1ApiArg = {
  /** Tenant ID */
  id: string;
};
export type PostApiTokenV1ApiResponse = /** status 200 OK */ {
  token?: string;
};
export type PostApiTokenV1ApiArg = {
  /** Controller and Tenant ID (only for token issuing) */
  body: {
    controllerId?: string;
    tenantId?: string;
  };
};
export type GetApiUsersV1ApiResponse =
  /** status 200 OK */ GithubComNergySeNubesPkgApiV1ModelsUser[];
export type GetApiUsersV1ApiArg = void;
export type GithubComNergySeNubesPkgApiV1ModelsMeter = {
  address?: string;
  controllerId?: string;
  id?: string;
  interfaceType?: string;
  /** Meter model */
  model?: string;
  /** where is the meter connected heatpump */
  position?: string;
  primaryId?: string;
};
export type GithubComNergySeNubesPkgApiV1ModelsControllerConfig = {
  /** Configured manual COP if we cannot calculate it */
  COP?: number;
  /** where to connect to the heatpump can be different thing depending on type. For thermiagenesis its an ip address. */
  address?: string;
  allowedMaxIndoorTemp?: number;
  allowedMinHotWaterTemp?: number;
  allowedMinIndoorTemp?: number;
  /** Always consider price sheep if below this level */
  consideredCheap?: number;
  controllerId?: string;
  currency?: string;
  /** Disabled is copied from Controller.Disabled when serving config to the device. */
  disabled?: boolean;
  /** if not 0.0 we need to calculate if fjärrvärme is more ecomoic for that (day or hour?? TODO) */
  districtHeatingPrice?: number;
  electricBasePrice?: number;
  heatControlType?: string;
  heatCurve?: number[];
  heatCurveAdjust?: number;
  heatCurveControlEnabled?: boolean;
  heatingSeasonStopTemperature?: number;
  hotWaterBoostStartTemperature?: number;
  hotWaterBoostStopTemperature?: number;
  /** HotWaterHours how many hours during the cheapest period of one day we should prioritize hotwater. */
  hotWaterHours?: number;
  hotWaterNormalStartTemperature?: number;
  hotWaterNormalStopTemperature?: number;
  /** How to calculate the price level */
  levelFormula?: string;
  /** MaxLevel is 1-10 of the price level for -+12h in each hour */
  maxLevelHeating?: number;
  /** MaxLevel is 1-10 of the price level for -+12h in each hour */
  maxLevelHotwater?: number;
  meters?: GithubComNergySeNubesPkgApiV1ModelsMeter[];
};
export type GithubComNergySeNubesPkgApiV1ModelsInvoiceDetails = {
  address?: string;
  city?: string;
  email?: string;
  /** how often to invoice ever 3 or 12 months? */
  interval?: number;
  name?: string;
  postCode?: string;
};
export type GithubComNergySeNubesPkgApiV1ModelsRole = {
  key?: string;
  /** Rights     pq.StringArray `gorm:"many2many:role_rights;" json:"rights"` */
  rights?: string[];
};
export type GithubComNergySeNubesPkgApiV1ModelsUser = {
  email?: string;
  id?: string;
  name?: string;
  password?: string;
  /** TODO perhaps use */
  personalIdentityNumber?: string;
  roles?: GithubComNergySeNubesPkgApiV1ModelsRole[];
  tenants?: GithubComNergySeNubesPkgApiV1ModelsTenant[];
  username?: string;
};
export type GithubComNergySeNubesPkgApiV1ModelsTenant = {
  id?: string;
  invoiceDetails?: GithubComNergySeNubesPkgApiV1ModelsInvoiceDetails;
  name?: string;
  users?: GithubComNergySeNubesPkgApiV1ModelsUser[];
};
export type PkgApiserverWebhandlersControllersResponse = {
  availableVersion?: string;
  config?: GithubComNergySeNubesPkgApiV1ModelsControllerConfig;
  currentVersion?: string;
  disabled?: boolean;
  id?: string;
  lastUpdate?: string;
  location?: string;
  name?: string;
  online?: boolean;
  /** TODO keep this up to date */
  serial?: string;
  tenant?: GithubComNergySeNubesPkgApiV1ModelsTenant;
  tenantId?: string;
  type?: string;
};
export type GithubComNergySeNubesPkgApiV1ModelsController = {
  config?: GithubComNergySeNubesPkgApiV1ModelsControllerConfig;
  disabled?: boolean;
  id?: string;
  lastUpdate?: string;
  location?: string;
  name?: string;
  online?: boolean;
  /** TODO keep this up to date */
  serial?: string;
  tenant?: GithubComNergySeNubesPkgApiV1ModelsTenant;
  tenantId?: string;
  type?: string;
};
export type GithubComNergySeNubesPkgApiV1ModelsAdminCreateControllerRequest = {
  config?: GithubComNergySeNubesPkgApiV1ModelsControllerConfig;
  location?: string;
  name?: string;
  serial?: string;
  tenantId?: string;
  type?: string;
};
export type GithubComNergySeNubesPkgApiV1ModelsUpdateControllerRequest = {
  config?: GithubComNergySeNubesPkgApiV1ModelsControllerConfig;
  location?: string;
  name?: string;
  serial?: string;
  type?: string;
};
export type GithubComNergySeNubesPkgApiV1ModelsUpdate = {
  /** location on disk to serve the bundle. url should contain Update.Version */
  bundlePath?: string;
  /** the sha256 sum of the update file */
  hash?: string;
  id?: string;
  version?: string;
};
export type PkgApiserverWebhandlersUpdateResponse = {
  /** location on disk to serve the bundle. url should contain Update.Version */
  bundlePath?: string;
  /** the sha256 sum of the update file */
  hash?: string;
  id?: string;
  onUpdate?: GithubComNergySeNubesPkgApiV1ModelsController[];
  pendingUpdate?: GithubComNergySeNubesPkgApiV1ModelsController[];
  version?: string;
};
export type MeterData = {
  id?: string;
  l1_a?: number;
  l1_v?: number;
  l2_a?: number;
  l2_v?: number;
  l3_a?: number;
  l3_v?: number;
  model?: string;
  time?: string;
  vll?: number;
  vln?: number;
  w?: number;
  wh?: number;
};
export type GithubComNergySeNubesPkgApiV1StateState = {
  alarm?: boolean;
  brineIn?: number;
  brineOut?: number;
  compressor?: number;
  cop?: number;
  forwardSetpoint?: number;
  heatCarrierForward?: number;
  heatCarrierReturn?: number;
  heatingAllowed?: boolean;
  highPressureSidePressure?: number;
  hotGasCompressor?: number;
  hotwaterAllowed?: boolean;
  indoor?: number;
  indoorMax?: number;
  indoorMin?: number;
  indoorSetpoint?: number;
  lowPressureSidePressure?: number;
  mode?: number;
  outdoor?: number;
  pumpBrine?: number;
  pumpHeat?: number;
  pumpRadiator?: number;
  radiatorForward?: number;
  /** FINNS DENNA ENS? */
  radiatorReturn?: number;
  suctionGasTemperature?: number;
  superHeatTemperature?: number;
  switchValve?: boolean;
  time?: string;
  twcEndTankTemp?: number;
  twcReturnTemp?: number;
  twcSupplyTemp?: number;
  warmWater?: number;
};
export type PkgApiserverWebhandlersHourConfig = {
  heating?: boolean;
  hotwater?: boolean;
  hotwaterForce?: boolean;
  price?: number;
  time?: string;
};
export type PkgApiserverWebhandlersSchedule = {
  [key: string]: PkgApiserverWebhandlersHourConfig;
};
export type GithubComNergySeNubesPkgApiV1ModelsUpdateLog = {
  controller?: GithubComNergySeNubesPkgApiV1ModelsController;
  controllerId?: string;
  id?: string;
  /** info,warning,error */
  level?: string;
  message?: string;
  update?: GithubComNergySeNubesPkgApiV1ModelsUpdate;
  updateId?: string;
};
export type GithubComNergySeNubesPkgApiV1ModelsCreateControllerRequest = {
  config?: GithubComNergySeNubesPkgApiV1ModelsControllerConfig;
  location?: string;
  name?: string;
  serial?: string;
  type?: string;
};
export type GithubComNergySeNubesPkgApiV1ModelsAlarm = {
  clearedTime?: string;
  controllerId?: string;
  id?: string;
  message?: string;
  notificationSent?: boolean;
  time?: string;
};
export type GithubComNergySeNubesPkgApiV1ModelsNotificationSetting = {
  alarmFilter?: string;
  controller?: GithubComNergySeNubesPkgApiV1ModelsController;
  controllerId?: string;
  id?: string;
  user?: GithubComNergySeNubesPkgApiV1ModelsUser;
  userId?: string;
};
export type GithubComNergySeNubesPkgApiV1EnergyPrice = {
  currency?: string;
  level?: number;
  price?: number;
  /** gorm.Model `json:"-"` */
  time?: string;
};
export type PkgApiserverWebhandlersConsumptionRow = {
  avgPrice?: number;
  cost?: number;
  kwh?: number;
  price?: number;
  time?: string;
};
export const {
  useGetApiAdminControllersV1Query,
  useLazyGetApiAdminControllersV1Query,
  usePostApiAdminControllersV1Mutation,
  useGetApiAdminControllersV1ByIdQuery,
  useLazyGetApiAdminControllersV1ByIdQuery,
  usePutApiAdminControllersV1ByIdMutation,
  usePutApiAdminControllersV1ByIdDisabledV1Mutation,
  usePostApiAdminToolsV1TestSendEmailV1Mutation,
  useGetApiAdminUpdatesV1Query,
  useLazyGetApiAdminUpdatesV1Query,
  usePostApiAdminUpdatesV1Mutation,
  useGetApiAdminUpdatesV1ByIdQuery,
  useLazyGetApiAdminUpdatesV1ByIdQuery,
  usePutApiAdminUpdatesV1ByIdMutation,
  useDeleteApiAdminUpdatesV1ByIdMutation,
  usePostApiAdminUpdatesV1ByIdAssignMutation,
  useGetApiAdminUsersV1Query,
  useLazyGetApiAdminUsersV1Query,
  usePostApiAdminUsersV1Mutation,
  useGetApiAdminUsersV1ByIdQuery,
  useLazyGetApiAdminUsersV1ByIdQuery,
  usePutApiAdminUsersV1ByIdMutation,
  usePostApiAdminUsersV1ByIdResetPasswordMutation,
  usePostApiAdminUsersV1ByIdSendPasswordV1Mutation,
  usePostApiControllerAlarmV1Mutation,
  useDeleteApiControllerAlarmsV1Mutation,
  useGetApiControllerBundlesV1ByIdQuery,
  useLazyGetApiControllerBundlesV1ByIdQuery,
  useGetApiControllerConfigV1Query,
  useLazyGetApiControllerConfigV1Query,
  usePostApiControllerConfigV1Mutation,
  usePostApiControllerHeatcurveV1Mutation,
  usePostApiControllerMeterV1Mutation,
  usePostApiControllerMetricsV1Mutation,
  useGetApiControllerScheduleV1Query,
  useLazyGetApiControllerScheduleV1Query,
  usePostApiControllerUpdateLogV1Mutation,
  useGetApiControllerUpdateV1Query,
  useLazyGetApiControllerUpdateV1Query,
  useGetApiControllersV1Query,
  useLazyGetApiControllersV1Query,
  usePostApiControllersV1Mutation,
  useGetApiControllersV1ByIdQuery,
  useLazyGetApiControllersV1ByIdQuery,
  usePutApiControllersV1ByIdMutation,
  useGetApiControllersV1ByIdAlarmsV1Query,
  useLazyGetApiControllersV1ByIdAlarmsV1Query,
  useGetApiControllersV1ByIdLastmetricsV1Query,
  useLazyGetApiControllersV1ByIdLastmetricsV1Query,
  useGetApiControllersV1ByIdMetersettingsV1Query,
  useLazyGetApiControllersV1ByIdMetersettingsV1Query,
  usePostApiControllersV1ByIdMetersettingsV1Mutation,
  useGetApiControllersV1ByIdMetersettingsV1AndMeterQuery,
  useLazyGetApiControllersV1ByIdMetersettingsV1AndMeterQuery,
  usePutApiControllersV1ByIdMetersettingsV1AndMeterMutation,
  useDeleteApiControllersV1ByIdMetersettingsV1AndMeterMutation,
  useGetApiControllersV1ByIdMetricsV1Query,
  useLazyGetApiControllersV1ByIdMetricsV1Query,
  useGetApiControllersV1ByIdNotificationsettingsV1Query,
  useLazyGetApiControllersV1ByIdNotificationsettingsV1Query,
  usePostApiControllersV1ByIdNotificationsettingsV1Mutation,
  useGetApiControllersV1ByIdNotificationsettingsV1AndSettingQuery,
  useLazyGetApiControllersV1ByIdNotificationsettingsV1AndSettingQuery,
  usePutApiControllersV1ByIdNotificationsettingsV1AndSettingMutation,
  useDeleteApiControllersV1ByIdNotificationsettingsV1AndSettingMutation,
  useGetApiEnergyPricesV1Query,
  useLazyGetApiEnergyPricesV1Query,
  usePostApiLoginV1Mutation,
  useGetApiLogoutV1Query,
  useLazyGetApiLogoutV1Query,
  usePostApiResetPasswordV1ByTokenMutation,
  useGetApiSettingsV1Query,
  useLazyGetApiSettingsV1Query,
  usePutApiSettingsV1Mutation,
  useGetApiStatisticsConsumptionV1Query,
  useLazyGetApiStatisticsConsumptionV1Query,
  useGetApiTenantsV1Query,
  useLazyGetApiTenantsV1Query,
  usePostApiTenantsV1Mutation,
  useGetApiTenantsV1ByIdQuery,
  useLazyGetApiTenantsV1ByIdQuery,
  usePutApiTenantsV1ByIdMutation,
  usePostApiTenantsV1ByIdSupportLoginV1Mutation,
  usePostApiTokenV1Mutation,
  useGetApiUsersV1Query,
  useLazyGetApiUsersV1Query,
} = injectedRtkApi;
